export default {
  supTitle: {
    en: 'Candle Club',
  },
  title: {
    en: 'Treat yourself to a new scented candle every month!',
  },
  text: {
    en: 'Subscribe now, and get a luxe, hand-selected candle delivered to your door each month for {price}.',
  },
  buttonTitle: {
    en: 'Upgrade for just {price}',
  },
}
